import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPencil, faTimes } from "@fortawesome/pro-light-svg-icons";
import styled from "styled-components";
import {
  TicketContainer,
  TicketDot,
  TicketHeading,
  TicketInfo,
  TicketStatus,
  TicketSubtitle,
  TicketWrapper,
} from "../styles";
import { Ticket } from "src/types";
import { useNavigate } from "react-router-dom";
import RecurringScheduleActionModal from "./RecurringScheduleActionModal";
import { colors } from "src/styles";

const ManagerListItem = ({ ticket, isRedirectAllowed }: { ticket: Ticket; isRedirectAllowed?: boolean }) => {
  const navigate = useNavigate();
  const isRecurringScheduleRow = Boolean(ticket.recurringScheduleId);
  const hasLinkedWorkOrder = Boolean(ticket.linkedWonum);
  const [activeRecurringMode, setActiveRecurringMode] = useState<"edit" | "deactivate" | null>(null);
  const displayWonum = ticket.displayWonum || ticket.wonum;

  const notifyRefresh = () => {
    window.dispatchEvent(new CustomEvent("workrequests-refresh"));
  };

  const onRowClick = (wonum: string) => {
    if (isRecurringScheduleRow && !hasLinkedWorkOrder) {
      return;
    }
    if (isRedirectAllowed) {
      navigate(`/workrequests/${wonum}`, { state: { ticketNumber: wonum } });
    }
  };
  return (
    <TicketWrapper
      onClick={() => {
        onRowClick(ticket.wonum);
      }}
      key={ticket.wonum}
    >
      <TicketContainer>
        <TicketHeading>
          {displayWonum}: {ticket.description}
        </TicketHeading>
        <TicketSubtitle>
          <p>{ticket.dateCreated}</p>
          <TicketDot />
          <p>{ticket.location}</p>
        </TicketSubtitle>

        <TicketInfo>
          {<p>{ticket.classification}</p>}
          <TicketDot />
          <p>{ticket.serviceType}</p>
        </TicketInfo>
        <TicketStatus>
          <p>{ticket.priority}</p>
          <TicketDot />
          {<p>{ticket.status}</p>}
        </TicketStatus>
        {isRecurringScheduleRow && (
          <ActionButtonsRow onClick={(e) => e.stopPropagation()}>
            <ActionBtn
              type="button"
              aria-label="Monitor recurring schedule"
              title="Monitor"
              onClick={() =>
                navigate(`/workrequests/recurring-schedules/${ticket.recurringScheduleId}`, {
                  state: { ticket },
                })
              }
            >
              <FontAwesomeIcon icon={faEye} />
            </ActionBtn>
            <ActionBtn
              type="button"
              aria-label="Edit recurring schedule"
              title="Edit"
              onClick={() => setActiveRecurringMode("edit")}
            >
              <FontAwesomeIcon icon={faPencil} />
            </ActionBtn>
            <DangerActionBtn
              type="button"
              aria-label="Deactivate recurring schedule"
              title="Deactivate"
              onClick={() => setActiveRecurringMode("deactivate")}
            >
              <FontAwesomeIcon icon={faTimes} />
            </DangerActionBtn>
          </ActionButtonsRow>
        )}
      </TicketContainer>
      {isRecurringScheduleRow && activeRecurringMode && (
        <RecurringScheduleActionModal
          isOpen={true}
          mode={activeRecurringMode}
          scheduleId={ticket.recurringScheduleId}
          ticket={ticket}
          onClose={() => setActiveRecurringMode(null)}
          onCompleted={notifyRefresh}
        />
      )}
    </TicketWrapper>
  );
};

const ActionButtonsRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 10px;
`;

const ActionBtn = styled.button`
  border: 1px solid #1f2a37;
  background: #ffffff;
  color: #1f2a37;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 13px;
  cursor: pointer;
`;

const DangerActionBtn = styled(ActionBtn)`
  border-color: ${colors.red.default};
  color: ${colors.red.default};
`;

export default ManagerListItem;
